import React from 'react';

const RegionArticleFooter = (props) => {
  return (
    <div className="regional-articlefooter">
      <h3 className="regional-articlefooter__heading">{props.Heading}</h3>
    </div>
  );
};

export default RegionArticleFooter;
